// extracted by mini-css-extract-plugin
export default {"connect_icons":"ConnectIcons_connect_icons__-OiMM"};